export default function buildGetDealFeedback({
    apiEndpoint,
    apiTools
}) {
    return async function getDealFeedback(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/deal` 
        })
       
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });
        return await res.json();
    }
}